export const TIME_CONTROL_ULTRA_BULLET = "ultraBullet"
export const TIME_CONTROL_BULLET = "bullet"
export const TIME_CONTROL_BLITZ = "blitz"
export const TIME_CONTROL_RAPID = "rapid"
export const TIME_CONTROL_CLASSICAL = "classical"
export const TIME_CONTROL_CORRESPONDENCE = "correspondence"
export const TIME_CONTROL_DAILY = "daily"
export const FILTER_NAME_RATED = "rated"
export const FILTER_NAME_DOWNLOAD_LIMIT = "downloadLimit"
export const FILTER_NAME_OPPONENT = "opponent"
export const FILTER_NAME_ELO_RANGE = "eloRange"
export const FILTER_NAME_FROM_DATE = "fromDate"
export const FILTER_NAME_TO_DATE = "toDate"

export const SITE_LICHESS = "lichess"
export const SITE_CHESS_DOT_COM = "chesscom"
export const SITE_PGN_FILE = "pgnfile"
export const SITE_EVENT_DB = "eventdb"
export const SITE_PLAYER_DB = "playerdb"
export const SITE_OPENING_TREE_FILE = "opntfile"
export const SITE_ONLINE_TOURNAMENTS = "tournament"

export const MAX_DOWNLOAD_LIMIT = 2000
export const MAX_ELO_RATING = 3000

export const EVENT_CATEGORY_PGN_LOADER = "loader"
export const EVENT_CATEGORY_OPENING_BOOK = "openingBook"
export const EVENT_CATEGORY_SETTINGS = "settings"
export const EVENT_CATEGORY_LICHESS_LOGIN = "lichess"
export const EVENT_CATEGORY_MAIN_ACTION = "mainAction"
export const EVENT_CATEGORY_SEGMENT = "segment"
export const EVENT_CATEGORY_MOVES_LIST = "moves"
export const EVENT_CATEGORY_CONTROLS = "controls"
export const EVENT_CATEGORY_NAVIGATOR = "navigator"
export const EVENT_CATEGORY_CHESSBOARD = "chessboard"
export const EVENT_CATEGORY_ERROR = "error"
export const EVENT_CATEGORY_MESSAGE_SHOWN = "message"
export const EVENT_CATEGORY_GLOBAL_HEADER = "globalHeader"

export const ROOT_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
export const RACING_KINGS_ROOT_FEN="8/8/8/8/8/8/krbnNBRK/qrbnNBRQ w - - 0 1"

export const PLAYER_COLOR_WHITE = 'white'
export const PLAYER_COLOR_BLACK = 'black'

export const LOADER_ANIMATION_DURATION_MS = 500

export const OPENING_TREE_EMAIL = 'feedback@openingtree.com'
export const OPENING_TREE_REDDIT = 'opening_tree'
export const OPENING_TREE_LICHESS = 'vannooz'
export const OPENING_TREE_CHESS_COM = 'vannooz'
export const OPENING_TREE_DISCORD = 'https://discord.gg/hCwKkN8'

export const OPENING_TREE_FILE_CURRENT_VERSION = 2

export const ERROR_ACTION_REPORT = 'report'
export const ERROR_ACTION_VISIT_OLD_SITE = 'visitOld'
export const ERROR_ACTION_NONE = 'noAction'
export const LICHESS_NOT_LOGGED_IN = 0;
export const LICHESS_STATE_PENDING = 1;
export const LICHESS_LOGGED_IN = 2;
export const LICHESS_FAILED_FETCH = 3;

export const ERROR_SEVERITY_ERROR = "error";
export const ERROR_SEVERITY_WARNING = "warning";
export const ERROR_SEVERITY_SUCCESS = "success";

export const VARIANT_STANDARD = "standard";
export const VARIANT_RACING_KINGS = "racingkings";
export const VARIANT_THREE_CHECK = "threecheck";
export const VARIANT_KING_OF_THE_HILL = "kingofthehill";
export const VARIANT_CRAZYHOUSE = "crazyhouse";

export const CHESS_COM_RULES_STANDARD = "chess";
export const CHESS_COM_RULES_THREE_CHECK = "threeCheck";
export const CHESS_COM_RULES_KING_OF_THE_HILL = "kingofthehill";
export const CHESS_COM_RULES_CRAZYHOUSE = "crazyhouse";

export const LICHESS_PERF_RACING_KINGS = "racingKings"
export const LICHESS_PERF_THREE_CHECK = "threeCheck"
export const LICHESS_PERF_KING_OF_THE_HILL = "kingOfTheHill"
export const LICHESS_PERF_CRAZYHOUSE = "crazyhouse"
export const LICHESS_PERF_STANDARD = "standard"

export const LICHESS_HEADER_RACING_KINGS = "Racing Kings"
export const LICHESS_HEADER_THREE_CHECK = "Three-check"
export const LICHESS_HEADER_KING_OF_THE_HILL = "King of the Hill"
export const LICHESS_HEADER_STANDARD = "Standard"
export const LICHESS_HEADER_CRAZYHOUSE = "Crazyhouse"

export const OPENING_BOOK_TYPE_OFF = 'off'
export const OPENING_BOOK_TYPE_MASTERS = 'masters'
export const OPENING_BOOK_TYPE_LICHESS = 'lichess'

export const ALL_BOOK_RATINGS = ['1600','1800','2000','2200','2500']

export const SETTING_NAME_ORIENTATION = 'orientation'
export const SETTING_NAME_DARK_MODE = 'darkMode'
export const SETTING_NAME_MOVES_SETTINGS = 'movesSettings'

export const MILLISECS_IN_DAY = 1000 * 60 * 60 * 24;

export const LICHESS_HOST = 'https://lichess.org';
export const LICHESS_CLIENT_ID = 'openingtree.com';
